interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/class-four/mathematics/numbers", title: "Numbers" },
    { url: "/class-four/mathematics/numbers", title: "Roman Numerals" },
    { url: "/class-four/mathematics/numbers", title: "Addition" },
    { url: "/class-four/mathematics/numbers", title: "Subtraction" },
    { url: "/class-four/mathematics/numbers", title: "Multiplication" },
    { url: "/class-four/mathematics/numbers", title: "Division" },
    { url: "/class-four/mathematics/numbers", title: "Factors & Multiples" },
    { url: "/class-four/mathematics/numbers", title: "Fractions" },
    { url: "/class-four/mathematics/numbers", title: "Geometry" },
    { url: "/class-four/mathematics/numbers", title: "Perimeter & Area" },
    { url: "/class-four/mathematics/numbers", title: "Measurement" },
    { url: "/class-four/mathematics/numbers", title: "Time & Temperature" },
    { url: "/class-four/mathematics/numbers", title: "Data Handling" },
    { url: "/class-four/mathematics/numbers", title: "Patterns" },
];


export default topics;